function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Help from "../components/help";
import { uniqueId } from "../utils/unique-id";

var SnapshotItem =
/*#__PURE__*/
function (_Component) {
  _inherits(SnapshotItem, _Component);

  function SnapshotItem() {
    _classCallCheck(this, SnapshotItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(SnapshotItem).apply(this, arguments));
  }

  _createClass(SnapshotItem, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.helpId = uniqueId();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          lineStyle = _this$props.lineStyle,
          lineColor = _this$props.lineColor,
          valueColor = _this$props.valueColor,
          tooltip = _this$props.tooltip,
          tooltipPlacement = _this$props.tooltipPlacement,
          valueHint = _this$props.valueHint,
          icon = _this$props.icon;
      return React.createElement("div", {
        className: "SnapshotItem"
      }, React.createElement("div", {
        className: "SnapshotItem-line",
        style: {
          border: "1px ".concat(lineStyle, " ").concat(lineColor)
        }
      }), icon && React.createElement("div", {
        className: "SnapshotItem-upper-icon"
      }, icon), React.createElement("span", {
        className: "SnapshotItem-title"
      }, title), tooltip ? React.createElement(Help, {
        id: this.helpId,
        message: tooltip,
        tooltipPlacement: tooltipPlacement
      }) : null, React.createElement("h2", {
        className: "SnapshotItem-value",
        style: {
          color: valueColor
        }
      }, children), valueHint);
    }
  }]);

  return SnapshotItem;
}(Component);

_defineProperty(SnapshotItem, "propTypes", {
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  lineStyle: PropTypes.oneOf(['dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset']),
  lineColor: PropTypes.string,
  valueColor: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipPlacement: PropTypes.oneOf(['top', 'left', 'bottom', 'right']),
  valueHint: PropTypes.node,
  icon: PropTypes.node
});

export default SnapshotItem;